function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 8V6H3.09C4.47 3.61 7.05 2 10 2C13.72 2 16.85 4.56 17.74 8H19.8C18.87 3.44 14.84 0 10 0C6.73 0 3.82 1.58 2 4.01V2H0V8H6ZM14 12V14H16.91C15.53 16.39 12.95 18 9.99995 18C6.27995 18 3.14995 15.44 2.25995 12H0.199951C1.12995 16.56 5.15995 20 9.99995 20C13.27 20 16.18 18.42 18 15.99V18H20V12H14ZM11.4609 14L10.9629 12.2188H8.40234L7.89844 14H6.16406L8.95898 5.46875H10.4531L13.1953 14H11.4609ZM9.70312 7.67773L8.80664 10.8184H10.5762L9.70312 7.67773Z",
  fill: "black",
  fillOpacity: 0.6
});

function SvgGenerateText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateText);
export default __webpack_public_path__ + "static/media/generate_text.bec26216.svg";
export { ForwardRef as ReactComponent };